const UserSettings = {
    LANG_FA: 'fa',
    LANG_EN: 'en',
    CAL_PERSIAN: 'Solar Hejri',
    CAL_GREGORIAN: 'Gregorian',
    DOUBLE_CLICK_ACTION: 'Quick View',
    PRE_DOWNLOAD: false,
    THEME: 'default',
    STUDY_LIST_HEADERS: {
        patient_id_or_request_number: {tooltip: "", active: true},
        first_name: {tooltip: "", active: true},
        last_name: {tooltip: "", active: true},
        sex: {tooltip: "", active: true},
        birth_date: {tooltip: "", active: false},
        age: {tooltip: "", active: false},
        date: {tooltip: "", active: true},
        study_reason: {tooltip: "", active: false},
        modality: {tooltip: "", active: true},
        source_application_entity: {tooltip: "", active: false},
        patient_status: {tooltip: "", active: true},
        comments: {tooltip: "", active: true},
        report_type: {tooltip: "", active: true},
        admitted_status: {tooltip: "", active: false},
        report: {tooltip: "", active: false},
        referring_physicians_name: {tooltip: "", active: false},
        performing_physicians_name: {tooltip: "", active: false},
        operators_name: {tooltip: "", active: false},
        file_size: {tooltip: "", active: true},
    }
};

export default UserSettings;